<template>
  <v-row class="header ma-0 flex-grow-0">
    <v-col :cols="columns" class="d-flex align-center">
      <!-- Page title -->
      <span class="font-weight-bold mr-1">{{ headerText }}</span>

      <DocsLink :link="tooltipLink" />
    </v-col>
    <div class="d-flex align-center">
      <div v-if="showSwitching" data-id-e2e="btnRunSwitching">
        <v-btn
          primary
          :disabled="disabled || isJobRunning('switching')"
          @click="openSwitchingModal"
        >
          {{ $t('scenarioMeasuringPage.buttons.runSwitching') }}
        </v-btn>
      </div>
      <div v-if="showPrepareSwaps" data-id-e2e="btnRunPrepareSwaps">
        <v-btn
          primary
          :disabled="disabled || isJobRunning('prepareSwaps')"
          @click="$emit('trigger-job', prepareSwapsJob)"
        >
          {{ $t('scenarioMeasuringPage.buttons.runPrepareSwaps') }}
        </v-btn>
      </div>
    </div>
    <v-col />

    <v-dialog
      v-model="isSwitchingModalOpen"
      retain-focus
      max-width="450"
      content-class="rtls-dialog"
      @keydown.esc="closeSwitchingModal"
      @click:outside="closeSwitchingModal"
    >
      <BaseDialogCard
        ref="reRunConfirmation"
        :title="tkey('switchingWrapper.reRunConfirmation.title')"
        :border="true"
        @close="closeSwitchingModal"
      >
        <v-card-text class="text-h6">
          <strong>{{ tkey('switchingWrapper.reRunConfirmation.warning') }}</strong>
          <p>{{ tkey('switchingWrapper.reRunConfirmation.question') }}</p>
        </v-card-text>

        <template #footer>
          <v-card-actions class="justify-center">
            <v-btn primary @click="closeSwitchingModal">
              {{ tkey('switchingWrapper.reRunConfirmation.cancel') }}
            </v-btn>
            <v-btn secondary variant="flat" class="outlined-btn" @click="triggerSwitching">
              {{ tkey('switchingWrapper.reRunConfirmation.confirm') }}
            </v-btn>
          </v-card-actions>
        </template>
      </BaseDialogCard>
    </v-dialog>
  </v-row>
</template>

<script>
import { useInternationalization } from '@/composables/use-internationalization';
import { useScenariosStore } from '@/stores/scenarios';
import jobapi from '@enums/jobapi';
import { mapState } from 'pinia';

export default {
  props: {
    headerText: {
      required: true,
      type: String,
    },
    tooltipLink: {
      required: false,
      type: String,
      default: '',
    },
    showJob: {
      required: false,
      type: String,
      default: null,
    },
    columns: {
      required: false,
      type: Number,
      default: 2,
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false,
    },
  },

  emits: ['trigger-job'],

  setup() {
    const { tkey } = useInternationalization();
    return { tkey };
  },

  data() {
    return {
      switchingJob: jobapi.jobTypes.switching,
      prepareSwapsJob: jobapi.jobTypes.prepareSwaps,
      isSwitchingModalOpen: false,
    };
  },

  computed: {
    ...mapState(useScenariosStore, ['jobStatuses', 'isJobRunning']),

    showSwitching() {
      return this.showJob === this.switchingJob;
    },

    showPrepareSwaps() {
      return this.showJob === this.prepareSwapsJob;
    },

    isSwitchingComplete() {
      return this.jobStatuses.switching.status === jobapi.jobStatuses.finished;
    },
  },

  methods: {
    openSwitchingModal() {
      if (this.isSwitchingComplete) {
        this.isSwitchingModalOpen = true;
      } else {
        this.triggerSwitching();
      }
    },

    closeSwitchingModal() {
      this.isSwitchingModalOpen = false;
    },

    triggerSwitching() {
      this.$emit('trigger-job', this.switchingJob);
      this.closeSwitchingModal();
    },
  },
};
</script>
